import React, { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Thumbs up / thumbs down rating for one Blaack AI response.
 * Rendered only when requestId is known; the parent owns the POST to
 * ai/feedback via onRate(rating, comment).
 */
const AiFeedbackButtons = ({ requestId, value, onRate }) => {
  const [downOpen, setDownOpen] = useState(false);
  const [downComment, setDownComment] = useState('');

  if (!requestId) return null;

  const submitUp = () => {
    setDownOpen(false);
    onRate?.('up', null);
  };

  const submitDown = () => {
    onRate?.('down', downComment.trim() || null);
    setDownOpen(false);
  };

  return (
    <Box sx={{ mt: 0.75 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
        <Tooltip title="Good response">
          <IconButton
            size="small"
            sx={{ p: 0.25 }}
            color={value === 'up' ? 'success' : 'default'}
            onClick={submitUp}
            aria-label="Good response"
          >
            {value === 'up'
              ? <ThumbUpIcon sx={{ fontSize: 14 }} />
              : <ThumbUpOutlinedIcon sx={{ fontSize: 14 }} />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Bad response">
          <IconButton
            size="small"
            sx={{ p: 0.25 }}
            color={value === 'down' ? 'error' : 'default'}
            onClick={() => setDownOpen((v) => !v)}
            aria-label="Bad response"
          >
            {value === 'down'
              ? <ThumbDownIcon sx={{ fontSize: 14 }} />
              : <ThumbDownOutlinedIcon sx={{ fontSize: 14 }} />}
          </IconButton>
        </Tooltip>
        {value && (
          <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5, fontSize: "12 !important" }}>
            Thanks for the feedback
          </Typography>
        )}
      </Box>
      {downOpen && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 0.5 }}>
          <TextField
            size="small"
            fullWidth
            multiline
            maxRows={3}
            placeholder="What was wrong? (optional)"
            value={downComment}
            onChange={(e) => setDownComment(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontSize: '0.8rem' } }}
          />
          <IconButton size="small" color="primary" onClick={submitDown} aria-label="Send feedback">
            <SendIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => setDownOpen(false)} aria-label="Cancel feedback">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default AiFeedbackButtons;
